module.exports = __webpack_public_path__ + "event.11d8e3f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/event.png
// module id = 358
// module chunks = 0